import { api } from "@/lib/orgApi";

export function getPatientSummaryLayout() {
  return api.get("/patient-summary/layout").then((response) => response.data || {});
}

export function savePatientSummaryLayout(payload) {
  return api.put("/patient-summary/layout", payload).then((response) => response.data || {});
}
